<script lang="ts">
  import Button from '$lib/components/ui/button/button.svelte';
  import { toast } from 'svelte-sonner';

  let { user = $bindable({}), experience } = $props();

  let loading = $state(false);

  function handlePasswordReset() {
    // Emit accountUpdate event with type 'password' to trigger password reset email
    if (experience?.eventHub) {
      loading = true;
      toast.info('Sending password reset email...');
      experience.eventHub.emit('accountUpdate', {
        type: 'password',
        data: {},
      });
    } else {
      toast.error('Unable to reset password - event system not available');
    }
  }

  // Listen for accountUpdate response to update loading state
  $effect(() => {
    if (experience?.eventHub) {
      const handleUpdateComplete = (success: boolean) => {
        loading = false;
        if (success) {
          toast.success('Password reset email sent! Please check your inbox.');
        } else {
          toast.error('There was an error while sending the password reset email');
        }
      };

      experience.eventHub.on('accountUpdate:password:complete', handleUpdateComplete);

      return () => {
        experience.eventHub.off('accountUpdate:password:complete', handleUpdateComplete);
      };
    }
  });
</script>

<div class="flex !flex-col !px-4 pb-4 w-full">
  <div class="w-full">
    <div class="flex flex-col gap-4">
      <p class="text-sm text-gray-700">
        Click the button below to receive a password reset email. Follow the instructions in the email to reset your password.
      </p>
    </div>
  </div>
  <div class="flex justify-end gap-2 mt-4 shrink-0 w-full">
    <Button
      disabled={loading}
      onclick={() => handlePasswordReset()}
      class={` h-9 !px-4 !py-6 border-none !shadow-none  !text-sm font-normal hover:brightness-110 transition text-white !bg-[#004976] dark:!bg-[var(--theme-link)]`}>Reset my password</Button
    >
  </div>
</div>
